import React, { useContext, useState } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { getMediaLogo } from '../../utils/file';
import { useTranslation } from 'react-i18next';
import { CampaignContext } from '../../contexts/CampaignContext';
import usePlatformCardColors from '../../hooks/usePlatformCardColors';
import { Swiper, SwiperSlide } from 'swiper/react';

interface InstagramPostProps {
	staticContent?: boolean;
	multiple?: boolean;
	data?: { image: File; caption: string; type: string; dataType: string }[] | null;
}

const PreviewStaticTheme: React.FC<InstagramPostProps> = ({ data, multiple = true }) => {
	const [activeIndex, setActiveIndex] = useState<number>(0);
	const { selectedContentType, selectedPlatform } = useContext(CampaignContext);
	const { borderColorClass } = usePlatformCardColors(selectedPlatform!);
	const { t } = useTranslation();

	const handleSlideChange = (swiper: any) => {
		setActiveIndex(swiper.activeIndex);
	};
	return (
		<Box className={`relative rounded-2xl border ${borderColorClass}`}>
			<Box className="flex items-center justify-between px-3 py-2">
				<Typography className="text-base font-medium text-grey-900">{selectedContentType ? t(selectedContentType) : t('post')}</Typography>
				<Divider className={`mx-2 grow border ${borderColorClass}`} />
				<img src={getMediaLogo(selectedPlatform!)} alt={`${t(selectedPlatform!)} logo`} className="mb-1 h-8 w-8" />
			</Box>
			{multiple && <Divider className={`border-1 ${borderColorClass}`} />}
			<Box className="relative flex w-full flex-col items-center">
				<Swiper className={`w-full transition-all`} pagination={{ clickable: true }} onSlideChange={handleSlideChange}>
					{data && data.length > 0 && (
						<div className="absolute top-3 z-50 flex w-full justify-center gap-2 px-3">
							{Array(data.length)
								.fill(2)
								.map((item, index) => (
									<span key={item} className={`h-1 w-full rounded-sm ${activeIndex === index ? 'bg-white' : 'bg-gray-400'}`}></span>
								))}
						</div>
					)}
					{data &&
						data.map((item: any, index) => (
							<SwiperSlide key={index}>
								<div className={`relative`}>{item.type === 'image' ? <img src={item.dataType === 'image' ? URL.createObjectURL(item.image) : `/images/campaigns/${item.image}`} alt={`Post`} className={`h-96 w-full rounded-b-2xl object-cover`} /> : <video src={URL.createObjectURL(item.image)} className="h-64 w-full object-cover" controls />}</div>
							</SwiperSlide>
						))}
				</Swiper>
			</Box>
		</Box>
	);
};

export default PreviewStaticTheme;
